import UploadFileIcon from "@mui/icons-material/UploadFile";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { Accept, FileRejection, useDropzone } from "react-dropzone";

import { formatBytes } from "common";

import * as S from "./styled";
import * as SD from "../../../FileFormField/components/Dropzone/Dropzone.styled";

interface Props {
  file: File | null;
  accept: Accept;
  message: string | null;
  onFileAdded: (acceptedFiles: File[], rejectedFiles: FileRejection[]) => void;
}

export const FileUploadStep = ({ onFileAdded, message, file, accept }: Props) => {
  const { getRootProps, getInputProps } = useDropzone({
    onDrop: onFileAdded,
    accept,
    maxFiles: 1
  });

  return (
    <S.DialogContentContainer>
      <SD.DropzoneContainer {...getRootProps()}>
        <input {...getInputProps()} />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2
          }}
        >
          <Box>
            <UploadFileIcon color="primary" />
          </Box>
          <Typography align="center">Click to upload or drag and drop</Typography>
        </Box>
      </SD.DropzoneContainer>
      {message && <S.ImportError sx={{ mt: 2 }}>{message}</S.ImportError>}
      {file && (
        <Grid container sx={{ my: 3 }}>
          <Grid item>
            <Box sx={{ m: 1.5, ml: 0 }}>
              <UploadFileIcon color="primary" />
            </Box>
          </Grid>
          <Grid item>
            <Typography variant="subtitle1">{file.name}</Typography>
            <Typography variant="caption">{formatBytes(file.size)}</Typography>
          </Grid>
        </Grid>
      )}
    </S.DialogContentContainer>
  );
};
